import React from 'react';

const Auxiliary = ({ children }) => children;

export default Auxiliary;